import { GET_PRODUCTS, IS_LOADING_PRODUCTS } from "../actions/products";

const INITIAL_STATE = {
  products: [],
  isLoadingProducts: false,
};

const productsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTS:
      return {
        ...state,
        products: action.payload.products,
        // displayName: action.payload.displayName,
      };

    case IS_LOADING_PRODUCTS:
      return {
        ...state,
        isLoadingProducts: action.payload.isLoadingProducts,
      };

    default:
      return state;
  }
};

export default productsReducer;
